<template>
  <section>
    <MarketLivePreviewAmerican :pageLimit="pageLimit" :showMoreEventButton="showMoreEventButton" :showSports="showSports" :isInHomePage="isInHomePage" :sportId="sportId" v-if="getGameConsole === 'american'"/>
    <MarketLivePreviewTerminal :pageLimit="pageLimit" :showMoreEventButton="showMoreEventButton" :showSports="showSports" :isInHomePage="isInHomePage" :sportId="sportId" v-else-if="getGameConsole === 'terminal'"/>
    <MarketLivePreviewClassic :pageLimit="pageLimit" :showMoreEventButton="showMoreEventButton" :showSports="showSports" :isInHomePage="isInHomePage" :sportId="sportId" v-else/>



  </section>
</template>

<script>
  import {mapGetters} from 'vuex';
  import MarketLivePreviewClassic from "@/components/center_widgets/Live/previews/MarketLivePreviewClassic.vue";
  import MarketLivePreviewAmerican from "@/components/american/MarketLivePreviewAmerican.vue";
  import MarketLivePreviewTerminal from "@/components/terminal/MarketLivePreviewTerminal.vue";

  export default {
    name: 'MarketLivePreviewV8',
    props: {
      pageLimit: {type: Number, default: 100},
      showMoreEventButton: {type: Boolean, default: true},
      showSports: {type: Boolean, default: true},
      isInHomePage: {type: Boolean, default: false},
      /** When set, forces the live section to this sport on mount and on change (used inside PreliveSection). */
      sportId: {type: [Number, String], default: null},
    },
    components: {
      MarketLivePreviewClassic,
      MarketLivePreviewAmerican,
      MarketLivePreviewTerminal
    },
    data: () => ({
      // Constants exposed to the template (frozen → Vue skips deep observation)

    }),
    computed: {
      ...mapGetters({
        'getGameConsole': 'settings/getGameConsole',
      }),

    }
  };
</script>

